export const ADD_FRIEND_LISTS = "ADD_FRIEND_LISTS";
export const SET_FRIEND_LISTS = "SET_FRIEND_LISTS";
export const SET_MY_FRIEND_LIST_ID = "SET_OWNED_FRIEND_LIST_ID";
export const RESET_MY_FRIEND_LIST_ID = "RESET_OWNED_FRIEND_LIST_ID";
export const SET_INVITED_FRIEND_LIST_ID = "SET_GUEST_FRIEND_LIST_ID";
export const RESET_INVITED_FRIEND_LIST_ID = "RESET_GUEST_FRIEND_LIST_ID";
export const SET_FRIEND_LIST_LEVELS = "SET_FRIEND_LIST_LEVELS";
export const ADD_FRIEND_LIST_LEVEL = "ADD_FRIEND_LIST_LEVEL";
export const RESET_FRIEND_LISTS = "RESET_FRIEND_LISTS";
export const SET_FRIEND_LIST_PARTICIPANTS = "SET_FRIEND_LIST_PARTICIPANTS";
export const DELETE_FRIEND_LIST_PARTICIPANT = "DELETE_FRIEND_LIST_PARTICIPANT";
export const ADD_FRIEND_LIST_PARTICIPANT = "ADD_FRIEND_LIST_PARTICIPANT";
export const ADD_CHAT_ROOM = "ADD_CHAT_ROOM";
